
export default function MissionBanner() {
  return (
    <div className="bg-blue-600 text-white py-3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-sm md:text-base font-medium">
            Helping Veterans Rise with Dignity, Structure, and Independence.
          </p>
        </div>
      </div>
    </div>
  );
}
